import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: '54px'
    },
    previousButton: {
        color: theme.palette.button.default,
        border: '2px solid #465270',
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        minWidth: '145px',
        padding: '8px 28px',
        '&:hover': {
            border: '2px solid #465270'
        }
    },
    footerButton: {
        marginLeft: '16px'
    },
    title: {
        margin: '32px 0 18px'
    },
    description: {
        marginBottom: '16px',
        fontSize: '16px',
        fontWeight: 400
    },
    modal: {
        borderRadius: '50px', color: 'red'
    },
    main: {
        width: '940px',
        padding: 20
    },
    resultHeader: {
        fontSize: '20px',
        fontWeight: 700,
        color: theme.palette.primary.dark,
        marginBottom: '16px',
        paddingTop: theme.spacing(2)
    },
    field: {
        width: '300px',
        padding: '10px',
        textAlign: 'left'
    },
    resultLevel: {
        fontSize: '25px',
        textTransform: 'uppercase',
        color: '#52575c',
        fontWeight: 400
    },
    smallDivider: {
        display: 'block',
        height: 0,
        width: '92px',
        borderBottom: '3px solid #CACCCF',
        margin: '10px 0 10px'
    },
    resultText: {
        fontSize: 16,
        fontWeight: 400,
        margin: '16px 0'
    },
    resultInsights: {
        fontSize: '20px',
        fontWeight: 700,
        color: '#52575c',
        marginBottom: '16px'
    }
}))
